import { render, staticRenderFns } from "./PresentationSetupSelector.vue?vue&type=template&id=23eeb3f5&scoped=true&"
import script from "./PresentationSetupSelector.vue?vue&type=script&lang=ts&"
export * from "./PresentationSetupSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PresentationSetupSelector.vue?vue&type=style&index=0&id=23eeb3f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eeb3f5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23eeb3f5')) {
      api.createRecord('23eeb3f5', component.options)
    } else {
      api.reload('23eeb3f5', component.options)
    }
    module.hot.accept("./PresentationSetupSelector.vue?vue&type=template&id=23eeb3f5&scoped=true&", function () {
      api.rerender('23eeb3f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/presentationOptions/PresentationSetupSelector.vue"
export default component.exports